globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.AddMediaAbstractFiles = (function(superClass) {

  utils.extend(AddMediaAbstractFiles, superClass);

  function AddMediaAbstractFiles() {
    AddMediaAbstractFiles.__super__.constructor.apply(this, arguments);

    this.$buttonUploader = this.$html.find('.add-files');
    this.$filesContainer = this.$html.find('.files-container');
    this.hasUploadedFiles = false;

    DeviceQueries.init();
  }

  $.extend(AddMediaAbstractFiles.prototype, {
    init: function() {
      var modal = this;

      modal._initUploader();

      modal.$html.on('click', 'button.submit', function(){
        appCustomerSpace.Loader().start({$container: modal.$html.find('.modal-content')})
        location.reload();
      });

      modal.$html.on('click', '.delete-media-file', function(){
        var $file = $(this).closest('.file');
        appCustomerSpace.Loader().start({ $container: $file, options: { text: '', icon_size: '2x' } });

        modal._deleteFile($file, function(){
          modal._refreshSubmitState();
        });
      });

      modal.$html.on('click', '.cancel', function() {
        if(modal.hasUploadedFiles) {
          appCustomerSpace.Loader().start({
            $container: modal.$html.find('.modal-content'),
            options: {
              text: "Annulation...",
              style: {
                backdrop: {
                  background: '#FFF'
                }
              }
            }
          });

          modal.$filesContainer.css('height', modal.$filesContainer.height() + 'px');
          modal.$html.find('.file.success').each(function(){
            modal._deleteFile($(this), function(){
              if(!modal.$filesContainer.find('.file.success').length) {
                modal.close();
              }
            });
          });
        } else {
          modal.close();
        }

      });

      return AddMediaAbstractFiles.__super__.init.apply(this, arguments);
    },
    _initUploader: function(){
      var _this = this,
          data  = {};

      this.uploader = new Uploader(this.$html, {
        data : data,
        progress : {
          percent     : '.file-percent',
          progressbar : '.file-progressbar'
        },
        plupload : {
          drop_element  : this.$filesContainer[0],
          browse_button : this.$buttonUploader[0],
          url: _this.ajaxResourcePath + '/upload'
        },
        callbacks : {
          filesAdded : function(up, files) {
            var files = Array.prototype.slice.call(files).reverse();

            for(var i = files.length - 1; i >= 0; i--) {
              _this._renderPreview(files[i]);
            }
          },
          uploadProgress : function(up, file) {
            var $preview = _this.$filesContainer.find('#' + file.id),
                percent = file.percent + '%';

            $preview.find(this.config.progress.percent).text(percent).end()
                    .find(this.config.progress.progressbar).css('width', percent);
          },
          fileUploaded : function(up, file, response) {
            if(response.error && response.error.file_size) {
              _this.$filesContainer.find('#' + file.id).append(`<span class='text-danger m-10 display-inline-block'>${response.error.file_size[0]}<span>`);
              setTimeout(function(){
                _this.$filesContainer.find('#' + file.id).fadeOut(function(){ $(this).remove(); });
              }, 5000);
            } else {
              var $file = $(response.views.new_thumbnail);
              _this.$filesContainer.find('#' + file.id).replaceWith($file);
              _this._refreshSubmitState();
            }
          }
        }
      });
    },
    _deleteFile: function($file, callback){
      var _this = this;
      $.post(_this.ajaxResourcePath + '/' + $file.data('uniq-key'), { _method: 'DELETE' }, function(data) {
        $file.fadeOut(90, function(){
          $file.remove();
          if(typeof callback == 'function') callback(data);
        });
      });
    },
    _refreshSubmitState: function(){
      if(this.$filesContainer.find('.file.success').length) {
        this.hasUploadedFiles = true
        this.$html.find('button.submit').prop('disabled', false)
      } else {
        this.hasUploadedFiles = false;
        this.$html.find('button.submit').prop('disabled', true)
      }
    },
    _renderPreview: function(file) {
      if(file) {
        var preview = this._$template().clone().attr('id', file.id);
        this.$filesContainer.prepend(preview.fadeIn(90));
      }
    },
    _$template: function(){
      return $(this.$filesContainer.find('template').html().trim());
    }
  });

  return AddMediaAbstractFiles;

})(appCustomerSpace.Modal);
